/**
 * Retrieves a ValueProvider from the widget's root parameters based on the given type.
 *
 * @param {WidgetProps<any, any>} props - The widget properties containing root-level parameters.
 * @param {string} type - The identifier of the ValueProvider to locate.
 * @returns {ValueProvider | undefined} The matched ValueProvider if found; otherwise, undefined.
 */
export function findValueProvider(props, type) {
    if (Array.isArray(props.rootParams.valueProviders)) {
        return props.rootParams.valueProviders.find((p) => p.type === type && typeof p.getValues === 'function');
    }
    else {
        return undefined;
    }
}
